import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import { Helmet } from 'react-helmet';

function Canonincalize({ urlLocation }) {
    const { context: { hostName = 'www.jcpenney.com' } = {} } = useSelector((store) => store);

    return (
        <Helmet>
            <link
                data-react-helmet="true"
                rel="canonical"
                href={`https://${hostName}${urlLocation}`}
            />
        </Helmet>
    );
}

Canonincalize.defaultProps = {
    urlLocation: '',
};

Canonincalize.propTypes = {
    urlLocation: PropTypes.string,
};

export default Canonincalize;
